import { Link } from "react-router-dom";

export default function ClosingCta() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-10 lg:grid-cols-[1.15fr_0.85fr]">
          <div>
            <p className="text-xs tracking-[0.24em] text-secondary-700">ABOUT US</p>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              这不只是一场颜值评审
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700">
              反差档案更像一份风格成长记录。我们更关心的是：一个人怎么从不会打光、不懂造型，
              慢慢找到适合自己的样子。所有内容基于公开信息整理，尊重每一位创作者，也欢迎当事人随时联系我们更正。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/about"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-information-line"></i>
                了解我们的内容原则
              </Link>
              <Link
                to="/contact"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-500 px-5 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-100"
              >
                <i className="ri-chat-3-line"></i>
                提交线索或反馈
              </Link>
            </div>
          </div>

          <ul className="flex flex-col gap-3">
            <li className="flex items-start gap-3 rounded-md bg-background-50 p-4">
              <i className="ri-shield-check-line mt-0.5 text-lg text-primary-500"></i>
              <p className="text-sm text-foreground-700">
                不使用非公开素材，不进行画面篡改与恶意对比。
              </p>
            </li>
            <li className="flex items-start gap-3 rounded-md bg-background-50 p-4">
              <i className="ri-heart-3-line mt-0.5 text-lg text-primary-500"></i>
              <p className="text-sm text-foreground-700">
                不评判容貌，只记录造型、风格与镜头表现的变化。
              </p>
            </li>
            <li className="flex items-start gap-3 rounded-md bg-background-50 p-4">
              <i className="ri-edit-2-line mt-0.5 text-lg text-primary-500"></i>
              <p className="text-sm text-foreground-700">
                发现年份或账号对应有误，核实后第一时间修正。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}